import { down, up } from 'styled-breakpoints'
import styled from 'styled-components'

export const DiscoverHeading = styled.h2`
  color: #131717;
  font-size: 24px;
  font-weight: 700;
  line-height: 33px;
  margin: 60px 0 24px 0;
  ${down('md')} {
    margin: 32px 0px 16px 0px;
    font-size: 20px;
  }
`

export const DiscoverWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: -8px;
  margin-bottom: -8px;
`

export const DiscoverCard = styled.div`
  position: relative;
  display: flex;
  justify-content: end;
  flex-direction: column;
  height: 200px;
  background-color: aliceblue;
  border-radius: 12px;
  background-size: contain;

  /*   ${down('md')} {
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    height: 75px;
    background-color: #ffffff;
    box-shadow: 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
    margin: 0px -15px 10px 0px;
  } */
`

export const DiscoverCardImageLink = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  
  img {
    border-radius: 12px;
    transition: transform 0.5s cubic-bezier(0.19, 1, 0.22, 1);
  }

  &:hover {
    img {
      transform: scale(1.04);
    }
  }

  /*   ${up('md')} {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  } */
`
export const DiscoverCardElementLink = styled.a`
  /*   ${down('md')} {
    color: #131717;
  } */
`

export const DiscoverCardTitle = styled.div`
  position: relative;
  display: flex;
  background-color: #ffffff;
  color: #131717;
  height: 30px;
  width: 90px;
  z-index: 2;
  font-size: 16px;
  font-weight: 700;
  border-radius: 100px;
  gap: 10px;
  justify-content: center;
  align-items: center;
  /*   ${down('md')} {
    justify-content: flex-start;
    margin-left: 4px;
  } */
`
export const DiscoverCardCategory = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  margin: 6px 27px 16px 10px;
  z-index: 4;
  /*   ${down('md')} {
    background-color: #ffffff;
  } */
`
export const DiscoverCardCategoryElement = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  text-decoration: underline;
  margin: 8px 5px 0px 5px;
  /*   ${down('md')} {
    color: #131717;
  } */
`

export const DiscoverCardElementWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

export const SliderDiv = styled.div``

export const DiscoverCardFragment = styled.div``
